export const translations = {
    residential: {
        en: "Residential",
        fr: "Résidentiel",
        es: "Residencial"
    },
    commercial: {
        en: "Commercial",
        fr: "Commerciale",
        es: "Comercial"
    },
    plywoodCost: {
        en: "Plywood ft<sup>2</sup> ($)",
        fr: "Contreplaqué ($)",
        es: "Contrachapado ($)"
    },
    plywood: {
        en: "Plywood",
        fr: "Plywood",
        es: "Triplay"
    },
    lumberMbfHint: {
        en: `Current index got from <a href="https://markets.businessinsider.com/commodities/lumber-price" target="_blank">Markets Insider</a> portal. The calculator adjusts this cost to the different lumber sizes. For example, there is a premium for a 2x12 over 2x10 of approxmately 8%.`,
        fr: `L'indice actuel provient du portail <a href="https://markets.businessinsider.com/commodities/lumber-price" target="_blank">Markets Insider</a>. Le calculateur adapte ce coût aux différentes tailles de bois. Par exemple, il y a une prime d'environ 8% pour un 2x12 par rapport à un 2x10.`,
        es: `Índice actual obtenido del portal <a href="https://markets.businessinsider.com/commodities/lumber-price" target="_blank">Markets Insider</a>. La calculadora ajusta este coste a los diferentes tamaños de madera. Por ejemplo, hay una prima para un 2x12 sobre 2x10 de aproximadamente 8%.`
    },
    plywoodHint: {
        en: "Plywood hint.",
        fr: "Plywood hint.",
        es: "Plywood hint."
    },
    materialHint: {
        en: "Cost of material including reuse factor for plywood.",
        fr: "Coût du matériau, y compris le facteur de réutilisation pour le contreplaqué.",
        es: "Coste del material, incluido el factor de reutilización del contrachapado."
    },
    lumberHint: {
        en: "Estimated cost of lumber for the project.",
        fr: "Estimation du coût du bois pour le projet.",
        es: "Coste estimado de la madera para el proyecto."
    },
    sizeHint: {
        en: `There are three different sizes of Fastfoot: 50", 62", 74". The Estimator will select the one that matches your entered data.`,
        fr: `Il existe trois tailles différentes de Fastfoot : 50", 62", 74". L'estimateur sélectionnera celle qui correspond aux données que vous avez saisies.`,
        es: `Hay tres tamaños diferentes de Fastfoot: 50", 62", 74". El estimador seleccionará la que coincida con los datos introducidos.`
    },
    methodHint: {
        en: `<ul>
                The forming methods:
                <li><strong>"full"</strong> - the fabric forms both sides of the footing</li>
                <li><strong>"edge"</strong> - the fabric forms one side of the footing</li>
            </ul>`,
        fr: `<ul>
                Les méthodes de formation:
                <li><strong>"plein"</strong> - le tissu forme un côté de la semelle</li>
                <li><strong>"bord"</strong> - le tissu forme un côté de la semelle</li>
            </ul>`,
        es: `<ul>
                Los métodos de formación:
                <li><strong>"completo"</strong> - el tejido forma un lado de la suela</li>
                <li><strong>"borde"</strong> - el tejido forma un lado de la suela</li>
            </ul>`
    },
    addFooting: {
        en: "Add Footing",
        fr: "Ajouter un pied",
        es: "Agregar Pie"
    },
    width: {
        en: "Width (in)",
        fr: "Largeur (cm)",
        es: "Ancho (cm)"
    },
    perimeter: {
        en: "Lineal footage (ft)",
        fr: "Hauteur (m)",
        es: "Altura (m)"
    },
    height: {
        en: "Depth (in)",
        fr: "Périmètre (m)",
        es: "Perímetro (m)"
    },
    corners: {
        en: "Corners (#)",
        fr: "Coin (#)",
        es: "Esquinas (#)"
    },
    lumberCost: { 
        en: "Lumber MBF ($)",
        fr: "Béton",
        es: "Hormigón"
    },
    laborCost: {
        en: "Labor hour ($)",
        fr: "Travaux",
        es: "Trabajo"
    },
    material: {
        en: "Material",
        fr: "Matériaux",
        es: "Materias primas"
    },
    labour: {
        en: "Labour",
        fr: "Travaux",
        es: "Trabajo"
    },
    lumber: {
        en: "Lumber",
        fr: "Béton",
        es: "Hormigón"
    },
    results: {
        en: "Results",
        fr: "Résultats",
        es: "Resultados"
    },
    method: {
        en: "Method",
        fr: "Méthode",
        es: "Método"
    },
    size: {
        en: "Size",
        fr: "Taille",
        es: "Tamaño"
    },
    rolls: {
        en: "Rolls (#)",
        fr: "Roules (#)",
        es: "Rollo (#)"
    },
    summary: {
        en: "Summary",
        fr: "Résumé",
        es: "Resumen"
    },
    calculate: {
        en: "Calculate",
        fr: "Calculer",
        es: "Calcular"
    },
    reset: {
        en: "Reset",
        fr: "Réinitialiser",
        es: "Restablecer"
    },
    cost: {
        en: "Cost",
        fr: "Coût",
        es: "Coste"
    },
    qty: {
        en: "Qty",
        fr: "Qté",
        es: "Ctd"
    },
    columnForm: {
        en: "Column form",
        fr: "Forme de colonne",
        es: "Forma de columna"
    },
    sendReport: {
        en: "Send report",
        fr: "Envoyer le rapport",
        es: "Enviar informe"
    },
    total: {
        en: "Total",
        fr: "Total",
        es: "Total"
    },
    padWidth: {
        en: "Pad width (ft)",
        fr: "Largeur du coussinet (m)",
        es: "Anchura de la almohadilla (m)"
    },
    padLength: {
        en: "Pad length (ft)",
        fr: "Longueur du coussinet (m)",
        es: "Longitud de la almohadilla (m)"
    },
    padHeight: {
        en: "Pad depth (in)",
        fr: "Hauteur du coussinet (cm)",
        es: "Altura de la almohadilla (cm)"
    },
    numberPads: {
        en: "Number of pads",
        fr: "Nombre de coussinets",
        es: "Número de almohadillas"
    },
    residential: {
        en: "Residential",
        fr: "Résidentiel",
        es: "Residencial"
    },
    commercial: {
        en: "Commercial",
        fr: "Commerciale",
        es: "Comercial"
    },
    install_res_step_1_title:{
        en: "Setup screed boards",
        fr: "Mise en place des panneaux de chape",
        es: "Colocación de planchas de solado"
    },
    install_res_step_1_text: {
        en: `<p>Layout the outside footing stakes (steel or 1x4s) around the perimeter using a string line.</p>
            <p>Drive the stakes on this line about 6' on center. Reduce spacing for deeper footings or if the ground is less dense.</p>
            <p>Drive inside stakes opposite each outside stake using a 1x2 cut to footing width. Top of footing is 3” less than the footing contact width (see diagram above right).</p>`,
        fr: `<p>Disposez les piquets de la semelle extérieure (acier ou 1x4) autour du périmètre à l'aide d'un cordeau.</p>
            <p>Enfoncez les piquets sur cette ligne à environ 6 pieds de centre à centre. Réduisez l'espacement pour les semelles plus profondes ou si le sol est moins dense.</p>
            <p>Enfoncez les piquets intérieurs en face de chaque piquet extérieur à l'aide d'un 1x2 coupé à la largeur de la semelle. Le haut de la semelle est 3" de moins que la largeur de contact de la semelle (voir diagramme ci-dessus à droite).</p>`,
        es: `<p>Coloque las estacas exteriores de la zapata (de acero o 1x4) alrededor del perímetro utilizando una línea de cuerda.</p>
            <p>Coloque las estacas sobre esta línea a unos 6' entre centros. Reduzca el espaciado para zapatas más profundas o si el terreno es menos denso.</p>
            <p>Coloque las estacas interiores frente a cada estaca exterior utilizando un 1x2 cortado a la anchura de la zapata. La parte superior de la zapata es 3" menos que la anchura de contacto de la zapata (véase el diagrama de arriba a la derecha).</p>`
    },
    install_res_step_2_title:{
        en: "Stapling Fastfoot<sup>®</sup>",
        fr: "Agrafage Fastfoot<sup>®</sup>",
        es: "Grapado Fastfoot<sup>®</sup>"
    },
    install_res_step_2_text: {
        en: `<div>Fastfoot<sup>®</sup> easily adjusts to different footing depths. Determine the correct location of the fabric edge on the screedboard by:</div>
            <li>Layout the outside footing stakes (steel or 1x4s) around the perimeter using a string line.</li>
            <li>Drive the stakes on this line about 6' on center. Reduce spacing for deeper footings or if the ground is less dense.</li>
            <li>Drive inside stakes opposite each outside stake using a 1x2 cut to footing width. Top of footing is 3” less than the footing contact width (see diagram above right).</li>`,
        fr: `<div>Fastfoot<sup>®</sup> s'adapte facilement aux différentes profondeurs de semelles. Déterminez l'emplacement correct du bord du tissu sur le panneau de chape :</div>
            <li>Disposez les piquets de la semelle extérieure (acier ou 1x4) autour du périmètre à l'aide d'un cordeau.</li>
            <li>Plantez les piquets sur cette ligne à environ 6 pieds l'un de l'autre. Réduisez l'espacement pour les semelles plus profondes ou si le sol est moins dense.</li>
            <li>Enfoncez les piquets intérieurs en face de chaque piquet extérieur à l'aide d'un 1x2 coupé à la largeur de la semelle. Le haut de la semelle est 3" de moins que la largeur de contact de la semelle (voir diagramme ci-dessus à droite).</li>`,
        es: `<div>Fastfoot<sup>®</sup> se ajusta fácilmente a diferentes profundidades de zapata. Determine la ubicación correcta del borde de la tela en la plancha:</div>
            <li>Coloque las estacas exteriores de la zapata (de acero o 1x4) alrededor del perímetro utilizando una línea de cuerda.</li>
            <li>Coloque las estacas en esta línea a unos 6' entre centros. Reduzca el espaciado para zapatas más profundas o si el suelo es menos denso.</li>
            <li>Coloque las estacas interiores frente a cada estaca exterior utilizando un 1x2 cortado a la anchura de la zapata. La parte superior de la zapata es 3" menos que la anchura de contacto de la zapata (véase el diagrama de arriba a la derecha).</li>`
    },
    install_res_step_3_title:{
        en: "Install corners",
        fr: "Installer les coins",
        es: "Instalar esquinas"
    },
    install_res_step_3_text: {
        en: `<p>Using the edge line determined in step 2, staple corner edges to top of screed boards at 12” on center, using a hammer tacker with 3/8" staples.</p>
            <p>If sewn corners are not available, run fabric 16” past corner, cut and staple in position. Use sissors to trim on inside of corner. Continue in new direction.</p>`,
        fr: `<p>En utilisant la ligne de bord déterminée à l'étape 2, agrafez les bords des coins au sommet des planches de la chape à 12" de centre à centre, en utilisant une agrafeuse à marteau avec des agrafes de 3/8".</p>
            <p>Si vous ne disposez pas de coins cousus, passez le tissu à 16" du coin, coupez et agrafez en position. Utilisez des ciseaux pour couper l'intérieur du coin. Continuez dans la nouvelle direction.</p>`,
        es: `<p>Usando la línea de borde determinada en el paso 2, engrape los bordes de las esquinas a la parte superior de las tablas de la regla a 12" entre centros, usando un martillo con grapas de 3/8".</p>
            <p>Si no dispone de esquinas cosidas, pase la tela 16" más allá de la esquina, corte y grape en posición. Utilice tijeras para recortar el interior de la esquina. Continúe en la nueva dirección.</p>`
    },
    install_res_step_4_title:{
        en: "Install straights",
        fr: "Installer les droites",
        es: "Instalar rectas"
    },
    install_res_step_4_text: {
        en: `<p>Hammer tack two edges of the Fastfoot<sup>®</sup> roll  on top of the corner fabric with a 10" overlap. Unroll past next corner and cut with a 10" overlap. Hammer tack both edges 12" on center using the predetermined edge line.</p>
            <p>Nail center line to prevent movement by wind and concrete. Use sheathing tape on overlaps and nail holes to prevent concrete escaping form and moisture entering footing. If the ground will not support nails, use bricks or stones.</p>`,
        fr: `<p>Martelez deux bords du rouleau Fastfoot<sup>®</sup> sur le tissu de l'angle avec un chevauchement de 10". Déroulez le rouleau au-delà de l'angle suivant et coupez avec un chevauchement de 10". Martelez les deux bords à 12" de centre à centre en utilisant la ligne de bord prédéterminée.</p>
            <p>Clouez la ligne centrale pour éviter les mouvements dus au vent et au béton. Utilisez du ruban de revêtement sur les chevauchements et les trous de clouage pour éviter que le béton ne s'échappe du coffrage et que l'humidité ne pénètre dans la semelle. Si le sol ne supporte pas les clous, utiliser des briques ou des pierres.</p>`,
        es: `<p>Clave dos bordes del rollo Fastfoot<sup>®</sup> encima de la tela de la esquina con un solapamiento de 10". Desenrolle más allá de la siguiente esquina y corte con una superposición de 10". Clave ambos bordes a 12" en el centro usando la línea de borde predeterminada.</p>
            <p>Clavar la línea central para evitar el movimiento por el viento y el hormigón. Utilice cinta de revestimiento en los solapes y agujeros de clavado para evitar que el hormigón salga del encofrado y la humedad entre en la zapata. Si el suelo no soporta clavos, utilice ladrillos o piedras.</p>`
    },
    install_res_t_junctions_title: {
        en: "T-junctions",
        fr: "Carrefours en T",
        es: "Cruces en T"
    },
    install_res_t_junctions_text: {
        en: `Run fabric through junction. Cut an 'inverted T' in junction area with lower cut along footing width line. Fold and staple tabs. Run intersecting fabric into junction allowing a 10" overlap. Cut overlap along footing width line, and staple overlaping tabs to screed boards.`,
        fr: `Passez le tissu à travers la jonction. Découper un "T inversé" dans la zone de jonction, la coupe inférieure se faisant le long de la ligne de largeur de la semelle. Plier et agrafer les languettes. Faites passer le tissu qui se croise dans la jonction en prévoyant un chevauchement de 10". Couper le chevauchement le long de la ligne de largeur de la semelle et agrafer les languettes de chevauchement aux planches de la chape.`,
        es: `Pase la tela por la unión. Corte una "T invertida" en la zona de unión con el corte inferior a lo largo de la línea de anchura de la zapata. Doble y grape las lengüetas. Pase la tela de intersección por la unión dejando un solapamiento de 10". Corte el solapamiento a lo largo de la línea de anchura de la zapata y grape las lengüetas de solapamiento a las tablas de la solera.`
    },
    install_res_steps_title: {
        en: "Step installation",
        fr: "Installation par étapes",
        es: "Instalación por pasos"
    },
    install_res_steps_1_text: {
        en: `Drive pairs of 2x4 stakes into the ground and screw to upper and lower screed boards. Trim upper screed boards flush with vertical stakes. Drive additional stakes if the distance between the stake and bank is greater than 15”. Install lower level fabric.`,
        fr: `Enfoncez des paires de piquets de 2x4 dans le sol et vissez-les aux planches supérieures et inférieures de la chape. Coupez les planches de la chape supérieure au ras des piquets verticaux. Enfoncer des piquets supplémentaires si la distance entre le piquet et la berge est supérieure à 15". Installer le tissu du niveau inférieur.`,
        es: `Clave pares de estacas de 2x4 en el suelo y atorníllelas a las tablas de enrasar superior e inferior. Recorte las tablas de la regla superior a ras de las estacas verticales. Clave estacas adicionales si la distancia entre la estaca y el banco es superior a 15". Instale la tela del nivel inferior.`
    },
    install_res_steps_2_text: {
        en: `Run fabric up bank to form step. Most steps are too deep to form with a single fabric width. Either run two widths of fabric as edging or turn the fabric 90 degrees to obtain the required width.`,
        fr: `Faites remonter le tissu le long de la berge pour former la marche. La plupart des marches sont trop profondes pour être formées avec une seule largeur de tissu. Il faut soit poser deux largeurs de tissu comme bordure, soit tourner le tissu de 90 degrés pour obtenir la largeur requise.`,
        es: `Suba la tela por la orilla para formar el escalón. La mayoría de los escalones son demasiado profundos para formarlos con un solo ancho de tela. Coloque dos anchos de tela como borde o gire la tela 90 grados para obtener la anchura necesaria.`
    },
    install_res_steps_3_text: {
        en: `Install the upper level fabric with an 10” overlap. Cut the overlap on the footing width line, letting center portion hang down bank.`,
        fr: `Installez le tissu du niveau supérieur avec un chevauchement de 10". Couper le chevauchement sur la ligne de largeur de la semelle, en laissant la partie centrale pendre le long de la berge.`,
        es: `Instale la tela del nivel superior con un solapamiento de 10". Corte el solapamiento en la línea de anchura de la zapata, dejando que la parte central cuelgue de la orilla.`
    },
    install_res_steps_4_text: {
        en: `Screw plywood bulkhead in position and brace as required. Step fabric can also be installed without cutting, see website for installation details.`,
        fr: `Visser la cloison en contreplaqué et la renforcer si nécessaire. Le tissu de la marche peut également être installé sans être découpé, voir le site web pour les détails de l'installation.`,
        es: `Atornille el mamparo de contrachapado en su posición y apuntale según sea necesario. La tela del peldaño también puede instalarse sin cortarla; consulte los detalles de instalación en el sitio web.`
    },
    install_com_step_1_title: {
        en: "Setup screed boards",
        fr: "Mise en place des panneaux de chape",
        es: "Colocación de planchas de solado"
    },
    install_com_step_1_text: {
        en: `<p>Drive stakes around the perimeter of the proposed slab or footing at about 5' on center.</p>
            <p>SOLIDLY ATTACH SCREED BOARDS</p><p>Concrete produces downward tension in fabric. Use 3 nails or 2 screws (2-1/4") per stake.</p>
            <p>For slab edging use deeper edge lumber (2x6 or 2x8) if a flat face is required for exposed edge. For footings, drive stakes on the footing line, so the 1-1/2" will save concrete.</p>`,
        fr: `<p>Plantez des piquets autour du périmètre de la dalle ou de la semelle proposée, à environ 5 pieds d'intervalle.</p>
            <p>FIXER SOLIDEMENT LES PANNEAUX DE CHAPE</p><p>Le béton produit une tension vers le bas dans le tissu. Utilisez 3 clous ou 2 vis (2-1/4") par piquet.</p>
            <p>Pour les bordures de dalles, utiliser du bois de bordure plus profond (2x6 ou 2x8) si une face plane est requise pour la bordure exposée. Pour les semelles, enfoncer les piquets sur la ligne de semelle, de sorte que le 1-1/2" économise le béton.</p>`,
        es: `<p>Coloque estacas alrededor del perímetro de la losa o zapata propuesta a unos 5' entre centros.</p>
            <p>FIJAR SÓLIDAMENTE LAS PLANCHAS DE SOLADO</p><p>El hormigón produce una tensión descendente en el tejido. Utilice 3 clavos o 2 tornillos (2-1/4") por estaca.</p>
            <p>Para los bordes de la losa, utilice madera para bordes más profundos (2x6 ó 2x8) si se requiere una cara plana para el borde expuesto. Para las zapatas, coloque las estacas en la línea de la zapata, de modo que las 1-1/2" salven el hormigón.</p>`
    },
    install_com_step_2_title: {
        en: "Install Fastfoot<sup>®</sup>",
        fr: "Installer le Fastfoot<sup>®</sup>",
        es: "Instalar Fastfoot<sup>®</sup>"
    },
    install_com_step_2_text: {
        en: `<p>Staple the edge of the fabric to the top of the screed board using a hammer tacker with 3/8" staples on about 8" centers.</p>
            <p>Provide some slack in the fabric by using a 1x2 as shown to prevent excessive downward pressure. Nail fabric to ground at 4' centers to stop fabric pull-out from concrete pressure. Allow an 10" overlap on all joints.</p>`,
        fr: `<p>Agrafer le bord du tissu sur le dessus de la planche de la chape à l'aide d'une agrafeuse à marteau avec des agrafes de 3/8" à des intervalles d'environ 8".</p>
            <p>Prévoir un peu de mou dans le tissu en utilisant un 1x2 comme indiqué pour éviter une pression excessive vers le bas. Clouez le tissu au sol à des intervalles de 4 pieds pour empêcher l'arrachement du tissu sous la pression du béton. Prévoir un chevauchement de 10" sur tous les joints.</p>`,
        es: `<p>Engrape el borde de la tela a la parte superior del tablero de la regla utilizando un martillo grapador con grapas de 3/8" a unos 8" entre centros.</p>
            <p>Deje cierta holgura en la tela utilizando un 1x2 como se muestra para evitar una presión excesiva hacia abajo. Clave la tela al suelo a 4' entre centros para evitar que la tela se desprenda por la presión del hormigón. Deje un solapamiento de 10" en todas las juntas.</p>`
    },
    install_com_step_3_title: {
        en: "Corners",
        fr: "Coins",
        es: "Esquinas"
    },
    install_com_step_3_text: {
        en: `<p>For outside corners, fold fabric on ground and nail through three layers to hold in position. For inside corner, cut fabric on the ground to enable it to go around corner and nail in position.</p>`,
        fr: `<p>Pour les angles extérieurs, plier le tissu sur le sol et le clouer à travers les trois couches pour le maintenir en place. Pour les angles intérieurs, couper le tissu au sol pour qu'il puisse faire le tour de l'angle et le clouer en position.</p>`,
        es: `<p>Para las esquinas exteriores, doble la tela en el suelo y clave a través de tres capas para mantenerla en posición. Para las esquinas interiores, corte la tela en el suelo para que pueda rodear la esquina y clávela.</p>`
    },
    typicalWidthDepth: {
        en: "Typical width / depth",
        fr: "Largeur / profondeur typique",
        es: "Anchura / profundidad típicas"
    },
    maxSlabDepth: {
        en: "Max slab depth",
        fr: "Profondeur max. de la dalle",
        es: "Profundidad máx. de la losa"
    },
    rollSize: {
        en: "Roll size",
        fr: "Taille de rouleau",
        es: "Tamaño de rollo"
    },
    roll_size_description: {
        en: `Fastfoot<sup>®</sup> corners are presewn for rapid installation. Each corner measures 4' by 4'. With a 12" overlap the effective length of each corner is 6'. Three sizes are available:`,
        fr: `Les coins Fastfoot<sup>®</sup> sont pré-cousus pour une installation rapide. Chaque coin mesure 1.2 m par 1.2 m. Avec un chevauchement de 130 cm, la longueur effective de chaque coin est de 1.8 m. Trois tailles sont disponibles :`,
        es: `Las esquinas Fastfoot<sup>®</sup> están precosidas para una instalación rápida. Cada esquina mide 1.2 m por 1.2 m. Con un solapamiento de 130 cm, la longitud efectiva de cada esquina es de 1.8 m. Hay tres tamaños disponibles:`
    },
    technical: {
        en: "Technical",
        fr: "Technique",
        es: "Técnico"
    },
    specifications: {
        en: "Specifications",
        fr: "Caractéristiques",
        es: "Especificaciones"
    },
    structuralEngineerLetter: {
        en: "Structural Engineer's Letter",
        fr: "Lettre de l'ingénieur structurier",
        es: "Carta del ingeniero estructural"
    },
    structuralEngineerLetterOntario: {
        en: "Structural Engineer's Letter for Ontario",
        fr: "Lettre de l'ingénieur en structure pour l'Ontario",
        es: "Carta del ingeniero estructural para Ontario"
    },
    structuralEngineerLetterNovaScotia: {
        en: "Structural Engineer's Letter for Nova Scotia",
        fr: "Lettre de l'ingénieur en structure pour la Nouvelle-Écosse",
        es: "Carta del ingeniero estructural para Nova Scotia"
    },
    structuralEngineerLetterCalifornia: {
        en: "Structural Engineer's Letter for California",
        fr: "Lettre de l'ingénieur en structure pour le Californie",
        es: "Carta del ingeniero estructural para California"
    },
    electricalEngineerLetterUferRod: {
        en: "Electrical Engineer's Letter on Ufer Rod",
        fr: "Lettre d'un ingénieur électricien sur la tige Ufer",
        es: "Carta de un ingeniero eléctrico sobre la varilla Ufer"
    },
    CMHCReportOnMold: {
        en: "CMHC Report on Mold",
        fr: "Rapport CMHC sur la moule",
        es: "Informe CMHC sobre la molda"
    },
    fastfootInstallationGuide: {
        en: "Fastfoot<sup>®</sup> Installation Guide",
        fr: "Guide d'installation Fastfoot<sup>®</sup>",
        es: "Guía de instalación Fastfoot<sup>®</sup>"
    },
    materialSafetyDataSheet: {
        en: "Material Safety Data Sheet",
        fr: "Feuille de sécurité du matériau",
        es: "Hoja de seguridad del material"
    },
    testReportOnAingle: {
        en: "Test report on the angle of interface friction of Fastfoot<sup>®</sup> against itself",
        fr: "Rapport d'essai sur l'angle de frottement d'interface du Fastfoot<sup>®</sup> contre lui-même",
        es: "Informe de ensayo sobre el ángulo de fricción de interfaz de Fastfoot<sup>®</sup> contra sí mismo"
    },
    CSISpecifications: {
        en: "CSI Specifications",
        fr: "Caractéristiques CSI",
        es: "Especificaciones CSI"
    },
    engineerCertificateOntario: {
        en: "Engineer's certificate letter for Ontario",
        fr: "Lettre de certificat d'ingénieur pour l'Ontario",
        es: "Carta de certificado de ingeniero para Ontario"
    },
    marketingMaterials: {
        en: "Marketing Materials",
        fr: "Matériaux de marketing",
        es: "Materiales de marketing"
    },
    fastfootPointOfsaleDisplay: {
        en: "Fastfoot<sup>®</sup> Point-of-sale Display",
        fr: "Fastfoot<sup>®</sup> Présentoir de point de vente",
        es: "Expositor punto de venta Fastfoot<sup>®</sup>"
    },
    fastfootBrochure: {
        en: "Fastfoot<sup>®</sup> Brochure",
        fr: "Brochure Fastfoot<sup>®</sup>",
        es: "Fastfoot<sup>®</sup> folleto"
    },
    weight: {
        en: "Weight",
        fr: "Poids",
        es: "Peso"
    },
    qtyBox: {
        en: "Qty (box)",
        fr: "Qté (box)",
        es: "Ctd (caja)"
    },
    boxSize: {
        en: "Box size<br>LxWxH",
        fr: "Taille de la boîte<br>L x l x H",
        es: "Tamaño de la caja<br>L x An x Al"
    },
    boxWeigth: {
        en: "Box weight",
        fr: "Poids de la boîte",
        es: "Peso de la caja"
    },
    dealerBinder: {
        en: "Dealer Binder",
        fr: "Gabarit du distributeur",
        es: "Gabinete del distribuidor"
    },
    diameter: {
        en: "Column diameter (in)",
        fr: "Diamètre de la colonne (cm)",
        es: "Diámetro de la columna (cm)"
    },
    columnHeight: {
        en: "Column height (ft)",
        fr: "Hauteur de la colonne (m)",
        es: "Altura de la columna (m)"
    },
    length: {
        en: "Length (ft)",
        fr: "Longueur (m)",
        es: "Longitud (m)"
    },
    weight: {
        en: "Weight",
        fr: "Poids",
        es: "Peso"
    },
    columnHeight: {
        en: "Column height (ft)",
        fr: "Hauteur de la colonne (m)",
        es: "Altura de la columna (m)"
    },
    diameter: {
        en: "Column diameter (in)",
        fr: "Diamètre de la colonne (cm)",
        es: "Diámetro de la columna (cm)"
    },
    labourCostPerHour: {
        en: "Labour cost per hour",
        fr: "Coût laboraire par heure",
        es: "Coste de mano de obra por hora"
    },
    numberOfColumns: {
        en: "Number of columns",
        fr: "Nombre de colonnes",
        es: "Número de columnas"
    },
    cardboardLength: {
        en: "Cardboard tube length (ft)",
        fr: "Longueur du tube en carton (m)",
        es: "Longitud tubo de cartón (m)"
    },
    cardboardPrice: {
        en: "Cardboard tube price",
        fr: "Prix tube en carton",
        es: "Precio tubo de cartón"
    },
    calculate: {
        en: "Calculate",
        fr: "Calculer",
        es: "Calcular"
    },
    reset: {
        en: "Reset",
        fr: "Réinitialiser",
        es: "Restablecer"
    },
    cost: {
        en: "Cost",
        fr: "Coût",
        es: "Coste"
    },
    qty: {
        en: "Qty",
        fr: "Qté",
        es: "Ctd"
    },
    columnForm: {
        en: "Column form",
        fr: "Forme de colonne",
        es: "Forma de columna"
    },
    shipping: {
        en: "Shipping (ft<sup>3</sup>)",
        fr: "Expédition (m<sup>3</sup>)",
        es: "Envío (m<sup>3</sup>)"
    },
    strippingLabor: {
        en: "Stripping labor",
        fr: "Nettoyage laboral",
        es: "Mano de obra de desmontaje"
    },
    shippingCost: {
        en: "Shipping cost per ft<sup>3</sup>",
        fr: "Frais d'expédition par m<sup>3</sup>",
        es: "Gastos de envío por m<sup>3</sup>"
    },
    buyNow: {
        en: "Buy Now",
        fr: "Acheter",
        es: "Comprar ahora"
    },
    emailUs: {
        en: "Email us",
        fr: "Envíenos un correo electrónico",
        es: "Envoyez-nous un courriel"
    },
    callUs: {
        en: "Call us",
        fr: "Appeler nous",
        es: "Llámanos"
    },
    address: {
        en: "Address",
        fr: "Adresse",
        es: "Dirección"
    },
    becomeDealer: {
        en: "Become a dealer",
        fr: "Devenir revendeur",
        es: "Conviértase en distribuidor"
    },
    becomeDealerForm: {
        en: "Become a dealer form",
        fr: "Formulaire pour devenir revendeur",
        es: "Formulario para ser distribuidor"
    },
    delaerInDeal: {
        en: "How long have you been in business?",
        fr: "Depuis combien de temps êtes-vous en activité ?",
        es: "¿Cuánto tiempo lleva en el negocio?"
    },
    dealerLocations: {
        en: "Number of locations",
        fr: "Nombre de sites",
        es: "Número de emplazamientos"
    },
    dealerEmployees: {
        en: "Number of employees",
        fr: "Nombre d'employés",
        es: "Número de empleados"
    },
    dealerWarehouse: {
        en: "Size of warehouse",
        fr: "Taille de l'entrepôt",
        es: "Tamaño del almacén"
    },
    dealerProducts: {
        en: "Other concrete related products are you currently supplying",
        fr: "Autres produits liés au béton que vous fournissez actuellement",
        es: "Otros productos relacionados con el hormigón que suministra actualmente"
    },
    dealerDiameter: {
        en: "Diameter of column most popular in your market",
        fr: "Diamètre de la colonne la plus populaire sur votre marché",
        es: "Diámetro de columna más popular en su mercado"
    },
    dealerInfo: {
        en: "Please share any additional information",
        fr: "Veuillez nous faire part de toute information complémentaire",
        es: "Por favor, comparta cualquier información adicional"
    },
    country: {
        en: "Country",
        fr: "Pays",
        es: "País"
    },
    distance: {
        en: "Distance",
        fr: "Distance",
        es: "Distancia"
    },
    showDealers: {
        en: "Show dealers",
        fr: "Afficher les distributeurs",
        es: "Mostrar distribuidores"
    },
    next: {
        en: "Next",
        fr: "Suivant",
        es: "Siguiente"
    },
    previous: {
        en: "Previous",
        fr: "Précédent",
        es: "Anterior"
    },
    submit: {
        en: "Submit",
        fr: "Soumettre",
        es: "Enviar"
    },
    name: {
        en: "Name",
        fr: "Nom",
        es: "Nombre"
    },
    company: {
        en: "Company",
        fr: "Entreprise",
        es: "Empresa"
    },
    city: {
        en: "City",
        fr: "Ville",
        es: "Ciudad"
    },
    country: {
        en: "Country",
        fr: "Pays",
        es: "País"
    },
    phone: {
        en: "Phone",
        fr: "Téléphone",
        es: "Teléfono"
    },
    email: {
        en: "Email",
        fr: "Courriel",
        es: "Correo electrónico"
    },
    send: {
        en: "Send",
        fr: "Envoyer",
        es: "Enviar"
    },
    website: {
        en: "Website",
        fr: "Site web",
        es: "Página web"
    },
    social: {
        en: "Social media account",
        fr: "Compte de médias sociaux",
        es: "Cuenta en redes sociales"
    },
    wentWrong: {
        en: "We're sorry, but something went wrong. Please try again.",
        fr: "Nous sommes désolés, mais quelque chose a mal tourné. Veuillez réessayer.",
        es: "Lo sentimos, pero algo ha ido mal. Por favor, inténtelo de nuevo."
    },
    shopOnline: {
        en: "Shop Online"
    },
    successInvestorMessage: {
        en:  "<b>Thanks</b> for registering! We have many exciting new developments up and coming. We will keep you up to date on a monthly basis of our new products, projects and more. Stay tuned.",
    }
}